// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
=============== 
Navbar
===============
*/

nav {
    background: var(--clr-white);
    box-shadow: 0px 10px 10px -12px rgba(0, 0, 0, 0.3);
}

.nav-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 1rem;
}

.nav-toggle {
    font-size: 1.5rem;
    color: var(--clr-lega-purple);
    background: transparent;
    border-color: transparent;
    transition: var(--transition);
    cursor: pointer;
}

.nav-toggle.show-links {
    color: var(--clr-primary-1);
    transform: rotate(90deg);
}

.nav-logo {
    height: 30px;
}

.nav-center ul {
    margin-bottom: 0;
}

.nav-links a {
    color: var(--clr-grey-3);
    font-size: 1rem;
    text-transform: capitalize;
    letter-spacing: var(--spacing);
    display: block;
    padding: 0.5rem 1rem;
    transition: var(--transition);
}

.nav-links a:hover {
    background: var(--clr-primary-8);
    color: var(--clr-primary-5);
    padding-left: 1.5rem;
}

.nav-social-icons {
    display: none;
}

.links-container {
    height: 0;
    overflow: hidden;
    transition: var(--transition);
}

.show-container {
    height: 10rem;
}

@media screen and (min-width: 800px) {
    .nav-center {
        max-width: 1170px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.7rem 1rem;
    }
    .nav-header {
        padding: 0;
    }
    .nav-toggle {
        display: none;
    }
    .links-container {
        height: auto !important;
    }
    .nav-links {
        display: flex;
    }
    .nav-links a {
        padding: 0;
        margin: 0 0.5rem;
    }
    .nav-links a:hover {
        padding: 0;
        background: transparent;
    }
    .nav-social-icons {
        display: flex;
    }
    .nav-social-icons a {
        margin: 0 0.5rem;
        color: var(--clr-primary-5);
        transition: var(--transition);
    }
    .nav-social-icons a:hover {
        color: var(--clr-primary-7);
    }
}


/* 
###########
TOP BAR CSS
###########
*/

.top-bar {
    padding: 0.3rem 2rem;
    background-color: rgb(236, 236, 236);
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 9;
}

.slogan-container {
    display: flex;
    align-items: center;
}

.top-link-container {
    align-items: center;
}

.top-link-icons {
    display: flex;
    align-items: center;
}

ul.top-link-icons {
    margin-bottom: 0;
}

.top-link-icons a {
    margin: 0 0.5rem;
    color: var(--clr-lega-dark-purple);
    transition: var(--transition);
}

.top-link-icons a:hover {
    color: var(--clr-lega-purple);
}

.slogan {
    margin: 0 0.5rem 0 0;
}`, "",{"version":3,"sources":["webpack://./src/navbar/navbar.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;IACI,4BAA4B;IAC5B,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,0BAA0B;IAC1B,8BAA8B;IAC9B,cAAc;IACd,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;QACd,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,oBAAoB;IACxB;IACA;QACI,UAAU;IACd;IACA;QACI,aAAa;IACjB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,aAAa;IACjB;IACA;QACI,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,UAAU;QACV,uBAAuB;IAC3B;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,2BAA2B;QAC3B,6BAA6B;IACjC;IACA;QACI,2BAA2B;IAC/B;AACJ;;;AAGA;;;;CAIC;;AAED;IACI,oBAAoB;IACpB,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":["/*\r\n=============== \r\nNavbar\r\n===============\r\n*/\r\n\r\nnav {\r\n    background: var(--clr-white);\r\n    box-shadow: 0px 10px 10px -12px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.nav-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0.5rem 1rem;\r\n}\r\n\r\n.nav-toggle {\r\n    font-size: 1.5rem;\r\n    color: var(--clr-lega-purple);\r\n    background: transparent;\r\n    border-color: transparent;\r\n    transition: var(--transition);\r\n    cursor: pointer;\r\n}\r\n\r\n.nav-toggle.show-links {\r\n    color: var(--clr-primary-1);\r\n    transform: rotate(90deg);\r\n}\r\n\r\n.nav-logo {\r\n    height: 30px;\r\n}\r\n\r\n.nav-center ul {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.nav-links a {\r\n    color: var(--clr-grey-3);\r\n    font-size: 1rem;\r\n    text-transform: capitalize;\r\n    letter-spacing: var(--spacing);\r\n    display: block;\r\n    padding: 0.5rem 1rem;\r\n    transition: var(--transition);\r\n}\r\n\r\n.nav-links a:hover {\r\n    background: var(--clr-primary-8);\r\n    color: var(--clr-primary-5);\r\n    padding-left: 1.5rem;\r\n}\r\n\r\n.nav-social-icons {\r\n    display: none;\r\n}\r\n\r\n.links-container {\r\n    height: 0;\r\n    overflow: hidden;\r\n    transition: var(--transition);\r\n}\r\n\r\n.show-container {\r\n    height: 10rem;\r\n}\r\n\r\n@media screen and (min-width: 800px) {\r\n    .nav-center {\r\n        max-width: 1170px;\r\n        margin: 0 auto;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        padding: 0.7rem 1rem;\r\n    }\r\n    .nav-header {\r\n        padding: 0;\r\n    }\r\n    .nav-toggle {\r\n        display: none;\r\n    }\r\n    .links-container {\r\n        height: auto !important;\r\n    }\r\n    .nav-links {\r\n        display: flex;\r\n    }\r\n    .nav-links a {\r\n        padding: 0;\r\n        margin: 0 0.5rem;\r\n    }\r\n    .nav-links a:hover {\r\n        padding: 0;\r\n        background: transparent;\r\n    }\r\n    .nav-social-icons {\r\n        display: flex;\r\n    }\r\n    .nav-social-icons a {\r\n        margin: 0 0.5rem;\r\n        color: var(--clr-primary-5);\r\n        transition: var(--transition);\r\n    }\r\n    .nav-social-icons a:hover {\r\n        color: var(--clr-primary-7);\r\n    }\r\n}\r\n\r\n\r\n/* \r\n###########\r\nTOP BAR CSS\r\n###########\r\n*/\r\n\r\n.top-bar {\r\n    padding: 0.3rem 2rem;\r\n    background-color: rgb(236, 236, 236);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    z-index: 9;\r\n}\r\n\r\n.slogan-container {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.top-link-container {\r\n    align-items: center;\r\n}\r\n\r\n.top-link-icons {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\nul.top-link-icons {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.top-link-icons a {\r\n    margin: 0 0.5rem;\r\n    color: var(--clr-lega-dark-purple);\r\n    transition: var(--transition);\r\n}\r\n\r\n.top-link-icons a:hover {\r\n    color: var(--clr-lega-purple);\r\n}\r\n\r\n.slogan {\r\n    margin: 0 0.5rem 0 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
